import type { FC } from "react";

import { AppStrings } from "../../../utils/constants/AppStrings";
import styles from "./SettlementBadge.module.css";

export const betSettlementOptions = [
  { value: "Won", label: AppStrings.WON },
  { value: "Lost", label: AppStrings.LOST },
  { value: "Pushed", label: AppStrings.PUSHED },
  { value: "Cancelled", label: AppStrings.CANCELLED },
];

const COLOR_MAP: Record<string, string> = {
  Won: styles.won,
  Lost: styles.lost,
  Pushed: styles.pushed,
  Cancelled: styles.cancelled,
  "Rolled Back": styles.rolledBack,
};

interface SettlementBadgeProps {
  status: string;
  className?: string;
}

/**
 * @deprecated For new bet-settlement displays prefer composing `StatusBadge`
 * from `components/shared` directly: `<StatusBadge color={...}>{status}</StatusBadge>`.
 * `SettlementBadge` stays functional for existing consumers; migration is
 * deferred to a cleanup wave where each consumer is visually verified.
 */
const SettlementBadge: FC<SettlementBadgeProps> = ({ status, className }) => {
  const colorClass = COLOR_MAP[status] ?? "";
  return (
    <span
      className={`${styles.badge} ${colorClass}${className ? ` ${className}` : ""}`}
    >
      {status ?? "—"}
    </span>
  );
};

export default SettlementBadge;
